import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import PopupSelect from '../mypage/popup_select/PopupSelect';
import PopupOptions from '../mypage/popup_select/popup_select_component/PopupOptions';
import 'core-js/stable';
import 'slick-carousel';
import 'magnific-popup';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

class BusinessSkillsInformationEditor extends React.Component {
  render() {
    // ViewModeコンポーネントに、Rails View の 'react_component' タグで引き渡されたデータを渡す
    // （これらのデータは、それぞれのコンポーネントで 'props' 経由でアクセスできる）
    return (
      <ViewMode
        member={this.props.member}
        member_business_types={this.props.member_business_types}
        member_qualifications={this.props.member_qualifications}
        member_skill_courses={this.props.member_skill_courses}
        errors={this.props.errors}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
      />
    );
  }
}

class ViewMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // メッセージエリアをクリア
    const message_area = document.querySelector('div.message_area.profile');
    while (message_area.firstChild) {
      message_area.removeChild(message_area.firstChild);
    }
    // 編集ボタン押下後にインボイス番号のTを消す処理。
    this.props.member.invoice_number = this.props.member.invoice_number.replace(/^T/, "") 
    // 編集モードに遷移
    ReactDOM.render(
      <EditMode
        member={this.props.member}
        member_business_types={this.props.member_business_types}
        member_qualifications={this.props.member_qualifications}
        member_skill_courses={this.props.member_skill_courses}
        errors={{ qualification_etc: '', skill_course_etc: '', maker: '', results: '', public_enterprise_results: '', reference: '' }}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
      />,
      document.getElementById('business_skills_information_area')
    );
  }

  render() {
    function MemberBusinessTypesTag(props) {
      if (props.member_business_types.length === 0) {
        return <td>なし</td>
      } else {
        const member_business_types = props.member_business_types;
        const list = [];
        for (var i in member_business_types) {
          list.push(
            <div key={member_business_types[i].id} className="business_type_item">
              {member_business_types[i].name + '　　' + ((member_business_types[i].length && member_business_types[i].length > 0) ? '経験年数' + member_business_types[i].length + '年' : '経験なし')}
              <p className="font_m fs-88">＜仕事内容＞<br />{member_business_types[i].detail != null && member_business_types[i].detail.trim() ? member_business_types[i].detail : 'なし'}</p>
            </div>
          );
        }
        return (
          <td>
            { list}
          </td>
        );
      }
    }
    function MemberQualificationsTag(props) {
      const values = props.member_qualifications.map(r => r.name);
      return (
        <td>
          { values.length === 0 ? 'なし' : values.join('/')}
          <p className="font_m fs-88">＜その他の資格＞<br />{props.qualification_etc ? props.qualification_etc : 'なし'}</p>
        </td>
      );
    }
    function MemberSkillCoursesTag(props) {
      const values = props.member_skill_courses.map(r => r.name);
      return (
        <td>
          { values.length === 0 ? 'なし' : values.join('/')}
          <p className="font_m fs-88">＜その他の技能＞<br />{props.skill_course_etc ? props.skill_course_etc : 'なし'}</p>
        </td>
      );
    }

    // インボイス番号
    function InvoiceNumberValue(props) {
      const invoiceNumber = props.value;
      if (invoiceNumber && !invoiceNumber.startsWith('T')) {
        return "T" + invoiceNumber;
      } else {
        return invoiceNumber;
      }
    }

    // 建設業許可
    function BusinessPermitValue(props) {
      const BUSINESS_PERMIT = {
        1: "大臣許可",
        2: "知事許可",
        3: "一般建設業",
        4: "特定建設業",
      };
      // カンマ区切りの文字列を分割
      const values = props.value.split(",");   
      // 分割した文字列をループ処理
      const permitValues = values.map((value) => {
        // 数値に変換
        const numValue = parseInt(value, 10);
        // 種類を判定
        return BUSINESS_PERMIT[numValue] || "";
      });
      // スラッシュで結合
      return permitValues.join("/");
    }
    
    // CCUS登録
    function CcusRegistrationValue(props) {
      const levels = {
        1: 'CCUSレベル1',
        2: 'CCUSレベル2',
        3: 'CCUSレベル3',
        4: 'CCUSレベル4',
        5: 'CCUS事業者',
        6: 'なし',
      };
      return levels[props.value] || '';
    }

    return (
      <React.Fragment>
        <div className="industry">
          <h3 className="fs-113">業種・職種/資格・免許/実績</h3>
          <div className="btn_right edit"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
          <table className="edit">
            <tbody>
              <tr>
                <th>業種・職種</th>
                <MemberBusinessTypesTag member_business_types={this.props.member_business_types} />
              </tr>
              <tr>
                <th>資格・免許</th>
                <MemberQualificationsTag member_qualifications={this.props.member_qualifications} qualification_etc={this.props.member.qualification_etc} />
              </tr>
              <tr>
                <th>技能・講習</th>
                <MemberSkillCoursesTag member_skill_courses={this.props.member_skill_courses} skill_course_etc={this.props.member.skill_course_etc} />
              </tr>
              <tr>
                <th>法人番号</th>
                <td>{this.props.member.corporate_number}</td>
              </tr>
              <tr>
                <th>インボイス番号</th>
                <td><InvoiceNumberValue value={this.props.member.invoice_number} /></td>
              </tr>
              <tr>
                <th>建設業許可</th>
                <td><BusinessPermitValue value={this.props.member.business_permit} /></td>
              </tr>
              <tr>
                <th>CCUS登録</th>
                <td><CcusRegistrationValue value={this.props.member.ccus_registration} /></td>
              </tr>
              <tr>
                <th>取引・取扱メーカー</th>
                <td>{this.props.member.maker}</td>
              </tr>
              <tr>
                <th>工事（作業）・実績</th>
                <td className="label_textarea">{this.props.member.results}</td>
              </tr>
              <tr>
                <th>公共事業請負実績</th>
                <td>{this.props.member.public_enterprise_results}</td>
              </tr>
              <tr>
                <th>参考情報<br className="pc" />（請負工事価格など）</th>
                <td>{this.props.member.reference}</td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">業種・職種/資格・免許/実績</h4>
          <div className="btn_right_bottom edit"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
        </div>
      </React.Fragment>
    );
  }
}

class EditMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.state = {
      member: JSON.parse(JSON.stringify(this.props.member)),
      member_business_types: JSON.parse(JSON.stringify(this.props.member_business_types)),
      member_qualifications: JSON.parse(JSON.stringify(this.props.member_qualifications)),
      member_skill_courses: JSON.parse(JSON.stringify(this.props.member_skill_courses)),
      errors: JSON.parse(JSON.stringify(this.props.errors))
    };
    this.selectedBusinessTypes = React.createRef();
    this.selectedQualifications = React.createRef();
    this.selectedSkillCourses = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleClickMemberBusinessTypes = this.handleClickMemberBusinessTypes.bind(this);
    this.handleClickMemberQualifications = this.handleClickMemberQualifications.bind(this);
    this.handleClickMemberSkillCourses = this.handleClickMemberSkillCourses.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeCheckBox = this.handleChangeCheckBox.bind(this);
    this.handleChangeSelectedBusinessTypes = this.handleChangeSelectedBusinessTypes.bind(this);
    this.handleChangeSelectedQualifications = this.handleChangeSelectedQualifications.bind(this);
    this.handleChangeSelectedSkillCourses = this.handleChangeSelectedSkillCourses.bind(this);
    this.handleChangeBusinessTypeDetails = this.handleChangeBusinessTypeDetails.bind(this);
  }

  componentDidMount() {
    this.$selectedBusinessTypes = $(this.selectedBusinessTypes);
    this.$selectedBusinessTypes.on('change', this.handleChangeSelectedBusinessTypes);
    this.$selectedQualifications = $(this.selectedQualifications);
    this.$selectedQualifications.on('change', this.handleChangeSelectedQualifications);
    this.$selectedSkillCourses = $(this.selectedSkillCourses);
    this.$selectedSkillCourses.on('change', this.handleChangeSelectedSkillCourses);
  }

  componentWillUnmount() {
    this.$selectedBusinessTypes.off('change', this.handleChangeSelectedBusinessTypes);
    this.$selectedQualifications.off('change', this.handleChangeSelectedQualifications);
    this.$selectedSkillCourses.off('change', this.handleChangeSelectedSkillCourses);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // ボタン非活性
    let elements = document.querySelectorAll('.btn_target');
    elements.forEach(function (element) {
      element.classList.add('btn_disabled');
    });
    // membersの更新
    fetch(this.props.update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.props.csrf_token
      },
      body: JSON.stringify({
        member: {
          qualification_etc: this.state.member.qualification_etc,
          skill_course_etc: this.state.member.skill_course_etc,
          corporate_number: this.state.member.corporate_number,
          invoice_number: this.state.member.invoice_number,
          business_permit: this.state.member.business_permit,
          ccus_registration: this.state.member.ccus_registration,
          maker: this.state.member.maker,
          results: this.state.member.results,
          public_enterprise_results: this.state.member.public_enterprise_results,
          reference: this.state.member.reference
        },
        member_business_types: this.state.member_business_types,
        member_qualifications: this.state.member_qualifications,
        member_skill_courses: this.state.member_skill_courses,
        authenticity_token: this.props.csrf_token
      })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      // メッセージエリアをクリア
      const message_area = document.querySelector('div.message_area.profile');
      while (message_area.firstChild) {
        message_area.removeChild(message_area.firstChild);
      }
      if (data.status == 200) {
        const member_business_types = [];
        for (var i in this.state.member_business_types) {
          member_business_types.push({
            id: this.state.member_business_types[i].id,
            name: this.state.member_business_types[i].name,
            length: this.state.member_business_types[i].length,
            detail: this.state.member_business_types[i].detail,
            length_error: '',
            detail_error: ''
          })
        }
        // ViewModeを再表示
        ReactDOM.render(
          <ViewMode
            member={this.state.member}
            member_business_types={member_business_types}
            member_qualifications={this.state.member_qualifications}
            member_skill_courses={this.state.member_skill_courses}
            errors={this.props.errors}
            update_url={this.props.update_url}
            csrf_token={this.props.csrf_token}
          />,
          document.getElementById('business_skills_information_area')
        );
        // 変更された項目があるとき
        if (Object.keys(data.saved_changes).length !== 0) {
          // 更新メッセージ表示
          const node = document.createElement('p');
          const message = document.createTextNode('プロフィールを更新しました。');
          node.appendChild(message);
          document.querySelector('div.message_area.profile').appendChild(node);
          // ページ上部の「業種」を更新
          const content = this.state.member_business_types.map(r => r.name).join('/');
          if (content.length === 0) { content = 'なし' }
          $('#mypage_area dl.industry_list dd#business_types').text(content);
          // 「プロフィール完成度」を更新
          if (data.saved_changes.profile_completeness) {
            $('div.chart_area dl dd.chart p span').css('display', 'none');
            $('div.chart_area dl dd.chart p').css('width', '0px');
            $('div.chart_area dl dd.chart p').animate({ width: data.saved_changes.profile_completeness[1] + '%' }, 1000, 'swing', function () { $('div.chart_area dl dd.chart p span').css('display', 'block') });
            $('div.chart_area dl dd.chart p span b').text(data.saved_changes.profile_completeness[1]);
          }
        }
      } else if (data.status == 400) {
        // 状態を更新
        this.setState({ member_business_types: data.member_business_types, errors: data.errors });
        // エラーメッセージ表示
        const node = document.createElement('p');
        const message = document.createTextNode('入力内容にエラーがあります。');
        node.appendChild(message);
        document.querySelector('div.message_area.profile').appendChild(node);
      }
      // ボタン活性
      let elements = document.querySelectorAll('.btn_target');
      elements.forEach(function (element) {
        element.classList.remove('btn_disabled');
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  // 業種・職種
  async handleClickMemberBusinessTypes(event) {
    event.preventDefault();

    const url = (() => {
      // URLを作成する
      const path = '/popup/member_business_types';
      const data = {
        selected_ids: this.state.member_business_types.map(r => r.id),
        is_limited_item: 1
      };
      return path + '?' + (new URLSearchParams(data)).toString();
    })();

    const data = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      return response.json();
    }).then(result => {
      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error("status is not 200");
      }
    }).catch(error => {
      console.error(new Error(error.message));
      alert('項目の取得中にエラーが発生しました。');
    });

    const onClosePopup = (selectedBusinessTypes) => {
      // 業種・職種の詳細情報{経験年数: length, 仕事内容: detail}が
      // ユーザ入力時に新要素としてmember_business_typesに追加される
      // set時にselectedBusinessTypesに上記要素を追加する必要がある
      for (let selectedBType of selectedBusinessTypes) {
        for (let prevBType of this.state.member_business_types) {
          if (selectedBType.id === prevBType.id) {
            selectedBType.length = prevBType.length || "";
            selectedBType.detail = prevBType.detail || "";
          }
        }
      }

      this.setState({ member_business_types: selectedBusinessTypes });
      $(this.selectedBusinessTypes).val(selectedBusinessTypes);
    };
    const rootNode = document.querySelector('#popup_industry');
    const ButtonArea = props => {
      return <a className="select select-industry-btn" onClick={props.onClickCloseButton}>選択</a>
    };
    ReactDOM.render(
      <PopupSelect
        popupOptions={PopupOptions.businessTypes}
        sectionTypes={data.sectionTypes}
        itemTypes={data.itemTypes}
        isLimitedItem={data.isLimitedItem}
        selectedIds={data.selectedIds.map(Number)}
        onClosePopup={onClosePopup}
        ButtonArea={ButtonArea}
        needSelectedAllButton={false}
        rootNode={rootNode}
      />, rootNode
    );
  }

  // 資格・免許
  async handleClickMemberQualifications(e) {
    e.preventDefault();

    const url = (() => {
      // URLを作成する
      const path = '/popup/member_qualifications';
      const data = { selected_ids: this.state.member_qualifications.map(r => r.id) };
      return path + '?' + (new URLSearchParams(data)).toString();
    })();

    const data = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      return response.json();
    }).then(result => {
      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error("status is not 200");
      }
    }).catch(error => {
      console.error(new Error(error.message));
      alert('項目の取得中にエラーが発生しました。');
    });

    const onClosePopup = (selectedQualifications) => {
      this.setState({ member_qualifications: selectedQualifications });
      $(this.selectedQualifications).val(selectedQualifications);
    };

    const rootNode = document.querySelector('#popup_industry');
    const ButtonArea = props => {
      return <a className="select select-qualification-btn" onClick={props.onClickCloseButton}>選択</a>
    };
    ReactDOM.render(
      <PopupSelect
        popupOptions={PopupOptions.qualifications}
        sectionTypes={data.sectionTypes}
        itemTypes={data.itemTypes}
        isLimitedItem={data.isLimitedItem}
        selectedIds={data.selectedIds.map(Number)}
        onClosePopup={onClosePopup}
        ButtonArea={ButtonArea}
        needSelectedAllButton={false}
        rootNode={rootNode}
      />, rootNode
    );
  }

  // 技能講習
  async handleClickMemberSkillCourses(e) {
    e.preventDefault();

    const url = (() => {
      // URLを作成する
      const path = '/popup/member_skill_courses';
      const data = { selected_ids: this.state.member_skill_courses.map(r => r.id) };
      return path + '?' + (new URLSearchParams(data)).toString();
    })();

    const data = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      return response.json();
    }).then(result => {
      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error("status is not 200");
      }
    }).catch(error => {
      console.error(new Error(error.message));
      alert('項目の取得中にエラーが発生しました。');
    });

    const onClosePopup = (selectedSkillCourses) => {
      this.setState({ member_skill_courses: selectedSkillCourses });
      $(this.selectedSkillCourses).val(selectedSkillCourses);
    };

    const rootNode = document.querySelector('#popup_industry');
    const ButtonArea = props => {
      return <a className="select select-skill-courses-btn" onClick={props.onClickCloseButton}>選択</a>
    };
    ReactDOM.render(
      <PopupSelect
        popupOptions={PopupOptions.skillCourses}
        sectionTypes={data.sectionTypes}
        itemTypes={data.itemTypes}
        isLimitedItem={data.isLimitedItem}
        selectedIds={data.selectedIds.map(Number)}
        onClosePopup={onClosePopup}
        ButtonArea={ButtonArea}
        needSelectedAllButton={false}
        rootNode={rootNode}
      />, rootNode
    );
  }

  handleChange(e) {
    const member = this.state.member;
    switch (e.target.id) {
      case 'qualification_etc':
        member.qualification_etc = e.target.value;
        break;
      case 'skill_course_etc':
        member.skill_course_etc = e.target.value;
        break;
      case 'corporate_number':
        member.corporate_number = e.target.value;
        break;
      case 'invoice_number':
        member.invoice_number = e.target.value;
        break;
      case 'ccus-radio-01':
        member.ccus_registration = 1;
        break;
      case 'ccus-radio-02':
        member.ccus_registration = 2;
        break;
      case 'ccus-radio-03':
        member.ccus_registration = 3;
        break;
      case 'ccus-radio-04':
        member.ccus_registration = 4;
        break;
      case 'ccus-radio-05':
        member.ccus_registration = 5;
        break;
      case 'ccus-radio-06':
        member.ccus_registration = 6;
        break;
      case 'maker':
        member.maker = e.target.value;
        break;
      case 'results':
        member.results = e.target.value;
        break;
      case 'public_enterprise_results':
        member.public_enterprise_results = e.target.value;
        break;
      case 'reference':
        member.reference = e.target.value;
    }
    // 状態を更新
    this.setState({ member: member });
  }

  handleChangeCheckBox(e) {
    const { id, checked } = e.target;
    const value = parseInt(id.split('_')[2], 10);
    const member = this.state.member;
  
    // チェック状態に応じて、business_permit の値を更新
    if (checked) {
      // 複数選択の場合
      if (member.business_permit.length > 0) {
        // 新しい値を追加
        member.business_permit += `,${value}`;
        // 配列に変換
        const values = member.business_permit.split(',');
        // 数字の若い順に並び替え
        values.sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
        // 配列を文字列に変換
        member.business_permit = values.join(',');
      } else {
        // 最初の値を設定
        member.business_permit = `${value}`;
      }
    } else {
      // チェック解除の場合
      const values = member.business_permit.split(',');
      // 削除する値を除外
      member.business_permit = values.filter(v => v !== `${value}`).join(',');
    }
    this.setState({ member: member });
  }

  handleChangeSelectedBusinessTypes(e) {
    const selected_business_types_value = '[]';
    if (e.target.value) {
      const member_business_types = this.state.member_business_types;
      selected_business_types_value = JSON.parse(e.target.value);
      for (var i in selected_business_types_value) {
        for (var ii in member_business_types) {
          if (member_business_types[ii].id === selected_business_types_value[i].id) {
            selected_business_types_value[i].length = member_business_types[ii].length;
            selected_business_types_value[i].detail = member_business_types[ii].detail;
            selected_business_types_value[i].length_error = member_business_types[ii].length_error;
            selected_business_types_value[i].detail_error = member_business_types[ii].detail_error;
          }
        }
      }
    }
    this.setState({ member_business_types: selected_business_types_value });
  }

  handleChangeSelectedQualifications(e) {
    const selected_qualifications_value = '[]';
    if (e.target.value) {
      selected_qualifications_value = e.target.value;
    }
    this.setState({ member_qualifications: JSON.parse(selected_qualifications_value) });
  }

  handleChangeSelectedSkillCourses(e) {
    const selected_skill_courses_value = '[]';
    if (e.target.value) {
      selected_skill_courses_value = e.target.value;
    }
    this.setState({ member_skill_courses: JSON.parse(selected_skill_courses_value) });
  }

  handleChangeBusinessTypeDetails(e) {
    const member_business_types = this.state.member_business_types;
    if (e.target.id.indexOf('business_type_length') === 0) {
      const business_type_id = parseInt(e.target.id.replace('business_type_length_', ''), 10);
      for (var i in member_business_types) {
        if (member_business_types[i].id === business_type_id) {
          member_business_types[i].length = e.target.value;
        }
      }
    } else if (e.target.id.indexOf('business_type_detail') === 0) {
      const business_type_id = parseInt(e.target.id.replace('business_type_detail_', ''), 10);
      for (var i in member_business_types) {
        if (member_business_types[i].id === business_type_id) {
          member_business_types[i].detail = e.target.value;
        }
      }
    }
    // 状態を更新
    this.setState({ member_business_types: member_business_types });
  }

  render() {
    function ErrorMessageTag(props) {
      if (props.item == '全体' && props.message) {
        return <div className="error_massage none_markup">エラー項目があります。</div>;
      } else if (props.item && props.message) {
        return <div className="error_massage">{props.item}{props.message}</div>;
      } else if (props.message) {
        return <div className="error_massage">{props.message}</div>;
      } else {
        return '';
      }
    }
    const member_business_type_details = [];
    for (var i in this.state.member_business_types) {
      member_business_type_details.push(
        <div key={this.state.member_business_types[i].id} className="business_type_item">
          {this.state.member_business_types[i].name}
          <ErrorMessageTag item={'業種・職種 経験年数'} message={this.state.member_business_types[i].length_error} />
          <p className="font_m fs-88">＜経験年数＞<br />
            <input id={'business_type_length_' + this.state.member_business_types[i].id}
              type="text"
              maxLength="2"
              min="0"
              value={this.state.member_business_types[i].length ? this.state.member_business_types[i].length : ''}
              onChange={this.handleChangeBusinessTypeDetails}
              className="w15"
            />&nbsp;年
          </p>
          <ErrorMessageTag item={'業種・職種 仕事内容'} message={this.state.member_business_types[i].detail_error} />
          <p className="font_m fs-88">＜仕事内容＞<br />
            <input id={'business_type_detail_' + this.state.member_business_types[i].id} maxLength="100" type="text" value={this.state.member_business_types[i].detail ? this.state.member_business_types[i].detail : ''} onChange={this.handleChangeBusinessTypeDetails} className="w100" />
          </p>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="industry input_group_area">
          <h3 className="fs-113">業種・職種/資格・免許/実績</h3>
          <div className="btn_right"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
          <ErrorMessageTag item={'全体'} message={this.state.errors ? Object.values(this.state.errors).join('') : ''} />
          <table className="business_skills_table edit">
            <tbody>
              <tr>
                <th>業種・職種<span className="required">(必須)</span><p className="input_note">※業種・職種は3つまで選択できます</p></th>
                <td>
                  <ErrorMessageTag item={'業種・職種'} message={this.state.errors.member_business_types} />
                  <a href="" className="inline_link area" data-id="area" onClick={this.handleClickMemberBusinessTypes}>
                    <input id="member_business_types" type="text" className={this.props.member_business_types.length !== 0 ? "w100 area completed" : "w100 area"} value={this.state.member_business_types.length > 0 ? this.state.member_business_types.map(r => r.name).join('/') : ''} placeholder={'業種・職種を選択'} readOnly />
                  </a>
                  <input type="hidden" id="selected_business_types" ref={selectedBusinessTypes => this.selectedBusinessTypes = selectedBusinessTypes} />
                  <div id="member_business_type_details">
                    {member_business_type_details}
                  </div>
                </td>
              </tr>
              <tr>
                <th>資格・免許</th>
                <td>
                  <a href="" className="inline_link area" data-id="area" onClick={this.handleClickMemberQualifications}>
                    <input id="member_qulifications" type="text" className={this.props.member_qualifications.length !== 0 ? "w100 area completed" : "w100 area"} value={this.state.member_qualifications.map(r => r.name).join('/')} placeholder={'資格・免許を選択'} readOnly />
                  </a>
                  <p className="font_m fs-88">＜その他の資格＞</p>
                  <ErrorMessageTag item={'その他の資格'} message={this.state.errors.qualification_etc} />
                  <input id="qualification_etc" maxLength="500" type="text" className={this.props.member.qualification_etc ? "w100 completed" : "w100"} value={this.state.member.qualification_etc} onChange={this.handleChange} />
                  <input type="hidden" id="selected_qualifications" ref={selectedQualifications => this.selectedQualifications = selectedQualifications} />
                </td>
              </tr>
              <tr>
                <th>技能・講習</th>
                <td>
                  <a href="" className="inline_link area" data-id="area" onClick={this.handleClickMemberSkillCourses}>
                    <input id="member_skill_courses" type="text" className={this.props.member_skill_courses.length !== 0 ? "w100 area completed" : "w100 area"} value={this.state.member_skill_courses.map(r => r.name).join('/')} placeholder={'技能・講習を選択'} readOnly />
                  </a>
                  <p className="font_m fs-88">＜その他の技能＞</p>
                  <ErrorMessageTag item={'その他の技能'} message={this.state.errors.skill_course_etc} />
                  <input id="skill_course_etc" maxLength="500" type="text" className={this.props.member.skill_course_etc ? "w100 completed" : "w100"} value={this.state.member.skill_course_etc} onChange={this.handleChange} />
                  <input type="hidden" id="selected_skill_courses" ref={selectedSkillCourses => this.selectedSkillCourses = selectedSkillCourses} />
                </td>
              </tr>
              <tr>
                <th>法人番号</th>
                <td className='corporate_number_wrapper'>
                  <ErrorMessageTag item={'法人番号'} message={this.state.errors.corporate_number} />
                  <p className="fs-88 font_m">13桁の数字を入力ください</p>
                  <input id="corporate_number" type="text" maxLength="13" value={this.state.member.corporate_number} onChange={this.handleChange} className={this.props.member.corporate_number ? "w100 completed" : "w100"} placeholder={'1234567890123'} />
                  <p className="fs-88 font_m">※半角数字</p>
                </td>
              </tr>
              <tr>
                <th>インボイス番号</th>
                <td className='invoice_number_wrapper'>
                  <ErrorMessageTag item={'インボイス番号'} message={this.state.errors.invoice_number} />
                  <p className="fs-88 font_m">13桁の数字を入力ください</p>
                  <div className='flex_group'>
                    <span>T</span>
                    <input id="invoice_number" type="text" maxLength="13" value={this.state.member.invoice_number} onChange={this.handleChange} className={this.props.member.invoice_number ? "w100 completed" : "w100"} placeholder={'1234567890123'} />
                  </div>
                  <p className="fs-88 font_m">※半角数字</p>
                </td>
              </tr>
              <tr>
                <th>建設業許可</th>
                <td>
                  <div className='label_checkbox_content'>
                    <input type="checkbox" id="construction_permit_1" name="construction_permit_1" value="1" className="checkbox-input" checked={this.state.member.business_permit.split(",").includes("1")} onChange={this.handleChangeCheckBox}/>
                    <label htmlFor="construction_permit_1" className="label_checkbox">大臣許可</label>
                  </div>
                  <div className='label_checkbox_content'>
                    <input type="checkbox" id="construction_permit_2" name="construction_permit_2" value="2" className="checkbox-input" checked={this.state.member.business_permit.split(",").includes("2")} onChange={this.handleChangeCheckBox}/>
                    <label htmlFor="construction_permit_2" className="label_checkbox">知事許可</label>
                  </div>
                  <div className='label_checkbox_content'>
                    <input type="checkbox" id="construction_permit_3" name="construction_permit_3" value="3" className="checkbox-input" checked={this.state.member.business_permit.split(",").includes("3")} onChange={this.handleChangeCheckBox}/>
                    <label htmlFor="construction_permit_3" className="label_checkbox">一般建設業</label>
                  </div>
                  <div className='label_checkbox_content'>
                    <input type="checkbox" id="construction_permit_4" name="construction_permit_4" value="4" className="checkbox-input" checked={this.state.member.business_permit.split(",").includes("4")} onChange={this.handleChangeCheckBox}/>
                    <label htmlFor="construction_permit_4" className="label_checkbox">特定建設業</label>
                  </div>
                  <p className="fs-88 font_m">※複数選択可</p>
                </td>
              </tr>
              <tr>
                <th>CCUS登録</th>
                <td>
                  <div className='label_radio_content'>
                    <input id="ccus-radio-01" type="radio" className="radio-input" value="1" onChange={this.handleChange} checked={this.state.member.ccus_registration == 1 } />
                    <label htmlFor="ccus-radio-01">CCUSレベル1</label>
                  </div>
                  <div className='label_radio_content'>
                    <input id="ccus-radio-02" type="radio" className="radio-input" value="2" onChange={this.handleChange} checked={this.state.member.ccus_registration == 2 } />
                    <label htmlFor="ccus-radio-02">CCUSレベル2</label>
                  </div>
                  <div className='label_radio_content'>
                    <input id="ccus-radio-03" type="radio" className="radio-input" value="3" onChange={this.handleChange} checked={this.state.member.ccus_registration == 3 } />
                    <label htmlFor="ccus-radio-03">CCUSレベル3</label>
                  </div>
                  <div className='label_radio_content'>
                    <input id="ccus-radio-04" type="radio" className="radio-input" value="4" onChange={this.handleChange} checked={this.state.member.ccus_registration == 4 } />
                    <label htmlFor="ccus-radio-04">CCUSレベル4</label>
                  </div>
                  <div className='label_radio_content'>
                    <input id="ccus-radio-05" type="radio" className="radio-input" value="5" onChange={this.handleChange} checked={this.state.member.ccus_registration == 5 } />
                    <label htmlFor="ccus-radio-05">CCUS事業者</label>
                  </div>
                  <div className='label_radio_content'>
                    <input id="ccus-radio-06" type="radio" className="radio-input" value="6" onChange={this.handleChange} checked={this.state.member.ccus_registration == 6 } />
                    <label htmlFor="ccus-radio-06">なし</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th>取引・取扱メーカー</th>
                <td>
                  <ErrorMessageTag item={'取引・取扱メーカー'} message={this.state.errors.maker} />
                  <input id="maker" type="text" maxLength="100" value={this.state.member.maker} onChange={this.handleChange} className={this.props.member.maker ? "w100 completed" : "w100"} />
                </td>
              </tr>
              <tr>
                <th>工事（作業）・実績</th>
                <td>
                  <ErrorMessageTag item={'工事（作業）・実績'} message={this.state.errors.results} />
                  <textarea id="results" maxLength="1000" className={this.props.member.results ? "input_textarea completed" : "input_textarea"} onChange={this.handleChange} defaultValue={this.state.member.results}></textarea>
                </td>
              </tr>
              <tr>
                <th>公共事業請負実績</th>
                <td>
                  <ErrorMessageTag item={'公共事業請負実績'} message={this.state.errors.public_enterprise_results} />
                  <input id="public_enterprise_results" maxLength="500" type="text" value={this.state.member.public_enterprise_results} onChange={this.handleChange} className={this.props.member.public_enterprise_results ? "w100 completed" : "w100"} />
                </td>
              </tr>
              <tr>
                <th>参考情報<br className="pc" />（請負工事価格など）</th>
                <td>
                  <ErrorMessageTag item={'参考情報（請負工事価格など）'} message={this.state.errors.reference} />
                  <input id="reference" type="text" maxLength="500" value={this.state.member.reference} onChange={this.handleChange} className={this.props.member.reference ? "w100 completed" : "w100"} />
                </td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">業種・職種/資格・免許/実績</h4>
          <div className="btn_right_bottom"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
        </div>
      </React.Fragment>
    );
  }
}

BusinessSkillsInformationEditor.propTypes = { member: PropTypes.object }

export default BusinessSkillsInformationEditor
